export type StrainType =
  | "Indica"
  | "Hybrid"
  | "Sativa"
  | "Indica-Dominant Hybrid"
  | "Sativa-Dominant Hybrid";

interface StrainTheme {
  textColor: string;
  backgroundColor: string;
}

const STRAIN_THEME_MAP: Record<string, StrainTheme> = {
  Indica: {
    textColor: "#087E8B",
    backgroundColor: "#B7E1E6",
  },
  "Indica-Dominant Hybrid": {
    textColor: "#087E8B",
    backgroundColor: "#B7E1E6",
  },
  Hybrid: {
    textColor: "#1CA65B",
    backgroundColor: "#E3F4E3",
  },
  Sativa: {
    textColor: "#E5063E",
    backgroundColor: "#FCE8ED",
  },
  "Sativa-Dominant Hybrid": {
    textColor: "#E5063E",
    backgroundColor: "#FCE8ED",
  },
};

export const getStrainTheme = (type: string): StrainTheme => {
  return (
    STRAIN_THEME_MAP[type] || {
      textColor: "#666",
      backgroundColor: "#F2F2F2",
    }
  );
};
